import axios from 'axios';
import React/* , { PropTypes } */ from 'react';
import { connect } from 'react-redux';
// import { browserHistory } from 'react-router';
import { bindActionCreators } from "redux";
import ReduxToastr from 'react-redux-toastr'
import CookieComponent from './CookieComponent';
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
  deviceDetect
} from "react-device-detect";
import * as dashboardActions from '../actions/dashboardActions';
const MINUTES_UNITL_AUTO_LOGOUT = 10 // in mins
// const MINUTES_UNITL_AUTO_LOGOUT = 1 // in mins
const CHECK_INTERVAL = 15000 // in ms
const STORE_KEY = 'lastAction';
// import * as AdminIndexAction from "../actions/admin/Index/adminIndexAction";
// import * as AdminIndexAction from "../../../actions/admin/Index/adminIndexAction.js";
var countries = require('country-data').countries

class App extends React.Component {
  constructor(props) {
    // var person = prompt("Password:");
    // if (person == 'Password@123') {
      
      // } else {
    //   location.reload();
    // }

    super(props);
    this.check();
    this.initListener();
    this.initInterval();
	
  }

	componentDidMount() {


		window.scrollTo(0, 0)
		navigator.geolocation.getCurrentPosition(
			function (position) {
				
				var lat = position.coords.latitude;
								var lng = position.coords.longitude;
								
								localStorage.setItem('lat', lat);
								localStorage.setItem('lng', lng);
								axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + "," + lng + '&key=AIzaSyBQQtO5Ia-kb95LB-pBnKeBDeN35Z2ybbk')
								.then(function (response) {
									if (response) {
										
										for (var i = 0; i < response.data.results.length; i++) {
											if (response.data.results[i].types[0] == 'country') {
												var countryshort = response.data.results[i].address_components[0].short_name;
												var countrylong = response.data.results[i].address_components[0].long_name;
												
												
												
												

												localStorage.setItem('country_short', countryshort)
												localStorage.setItem('country_long', countrylong)
												localStorage.setItem('currency', countries[countryshort].currencies[0]);
												localStorage.setItem('calling_code', countries[countryshort].countryCallingCodes[0]);
												localStorage.removeItem('mileDistance',0)
											}
											if(response.data.results[i].types[0] == "locality") {
												var locality = response.data.results[i].address_components[0].short_name;
												var localityState = response.data.results[i].address_components[2].long_name;
												var localityCountry = response.data.results[i].address_components[3].long_name;
												
												setTimeout(()=> {
													localStorage.setItem('locality', locality)
													localStorage.setItem('localityState', localityState)
													localStorage.setItem('localityCountry', localityCountry)
													console.log("----setimeout set on the app.js3000")
												}, 3000)

											}
										}
									}
									else {
									}
								})
			});


			// var device = deviceDetect();
		// localStorage.setItem('device',device);



	}
	getLastAction() {
		return parseInt(localStorage.getItem(STORE_KEY));
		// 
	}

	setLastAction(lastAction) {
		localStorage.setItem(STORE_KEY, lastAction.toString());
	}

	initListener() {
		document.body.addEventListener('click', () => this.reset());
		document.body.addEventListener('mouseover', () => this.reset());
		document.body.addEventListener('mouseout', () => this.reset());
		document.body.addEventListener('keydown', () => this.reset());
		document.body.addEventListener('keyup', () => this.reset());
		document.body.addEventListener('keypress', () => this.reset());
	}

	reset() {
		this.setLastAction(Date.now());
	}

	initInterval = () => {
		setInterval(() => {
			this.check();
		}, CHECK_INTERVAL);
	}

	check = () => {

		const now = Date.now();
		const timeleft = this.getLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
		const diff = timeleft - now;
		const isTimeout = diff < 0;

		
		if (isTimeout) {

			
			if (localStorage.getItem('userId')) {
				
				let userId = localStorage.getItem("userId");
				

		this.props.actions.logout({ userId: userId }, this.props);
		let locality = localStorage.getItem('locality')
        let localityState = localStorage.getItem('localityState')
        let localityCountry = localStorage.getItem('localityCountry')
        // event.preventDefault();
        localStorage.clear();
        localStorage.setItem('locality', locality)
        localStorage.setItem('localityState', localityState)
        localStorage.setItem('localityCountry', localityCountry)
        // localStorage.clear();
				// browserHistory.push('/')
			}
			localStorage.clear();
			// this.props.history.push('/')
		}
		// if (!isTimeout && localStorage.getItem('userId')) {
		// 	this.props.history.push(this.props.location.pathname)
		// }
	}


	render() {

		return (
			<div>
				<CookieComponent
					cookieName="medfixCookieConsent"
					expires={150}
				/>
				{/* <CookieBanner
      message="Medfix uses cookies to guarantee users the employment of its site features, offering a better  experience. By continuing to browse the site you're agreeing to our use of cookies."
			onAccept={() => {}}
			dismissOnScroll= 'false'
      cookie="user-has-accepted-cookies" /> */}
				{this.props.children}
				<ReduxToastr
					timeOut={4000}
					newestOnTop={false}
					preventDuplicates
					position="top-right"
					transitionIn="bounceInDown"
					transitionOut="bounceOutUp"
					progressBar />
			</div >
		);
	}
}
function mapStateToProps(state) {
	return {
		// actions: bindActionCreators(dashboardActions, dispatch)
	};
}
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(dashboardActions, dispatch)
	};
}
export default connect(
	mapStateToProps, mapDispatchToProps)(App);

// export default App
